/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Auto_DescInputs */

const en_model_auto_desc = /** @type {(inputs: Model_Auto_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep picks: the strongest model you have for the first draft, cheaper models for the rest.`)
};

const id_model_auto_desc = /** @type {(inputs: Model_Auto_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep yang memilih: model terkuat yang kamu punya untuk draf pertama, model lebih hemat untuk sisanya.`)
};

/**
* | output |
* | --- |
* | "Bystep picks: the strongest model you have for the first draft, cheaper models for the rest." |
*
* @param {Model_Auto_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const model_auto_desc = /** @type {((inputs?: Model_Auto_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Auto_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_model_auto_desc(inputs)
	return en_model_auto_desc(inputs)
});